import { render, staticRenderFns } from "./ModalSelecionarDocumentosDemanda.vue?vue&type=template&id=2837fa46&scoped=true"
import script from "./ModalSelecionarDocumentosDemanda.vue?vue&type=script&lang=js"
export * from "./ModalSelecionarDocumentosDemanda.vue?vue&type=script&lang=js"
import style0 from "./ModalSelecionarDocumentosDemanda.vue?vue&type=style&index=0&id=2837fa46&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2837fa46",
  null
  
)

export default component.exports